import { enIE } from "../../../../date-fns/locale/en-IE.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    enIE
  }
};